import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { blockTypeMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';
var nodeName = 'panel';
var PanelBlockMenuItem = function PanelBlockMenuItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var selection = useSharedPluginStateSelector(api, 'selection.selection');
  var isPanelSelected = useMemo(function () {
    if (!selection) {
      return false;
    }
    if (selection instanceof NodeSelection) {
      // Note: we are checking for any type of panel, not just of type infopanel
      return selection.node.type.name === nodeName;
    }
    return false;
  }, [selection]);
  var handleClick = function handleClick(event) {
    var _api$blockMenu;
    var triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? INPUT_METHOD.KEYBOARD : INPUT_METHOD.MOUSE;
    var inputMethod = INPUT_METHOD.BLOCK_MENU;
    selection && (api === null || api === void 0 ? void 0 : api.core.actions.execute(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(selection.$from.doc.type.schema.nodes.panel, {
      inputMethod: inputMethod,
      triggeredFrom: triggeredFrom
    })));
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: handleClick,
    isSelected: isPanelSelected,
    elemBefore: /*#__PURE__*/React.createElement(InformationCircleIcon, {
      label: ""
    })
  }, formatMessage(blockTypeMessages.panel));
};
export var createPanelBlockMenuItem = function createPanelBlockMenuItem(api) {
  return function () {
    return /*#__PURE__*/React.createElement(PanelBlockMenuItem, {
      api: api
    });
  };
};